import { render } from "./VueMain.vue?vue&type=template&id=9dd2d8ae"
import script from "./VueMain.vue?vue&type=script&lang=js"
export * from "./VueMain.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__